// tourSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface TourState {
    isFileUploadTourStarted: boolean
    // other state fields if any
}

const initialState: TourState = {
    isFileUploadTourStarted: false,
}

const tourSlice = createSlice({
    name: 'tour',
    initialState,
    reducers: {
        setFileUploadTourStarted(state, action: PayloadAction<boolean>) {
            state.isFileUploadTourStarted = action.payload
        },
    },
})

export const { setFileUploadTourStarted } = tourSlice.actions
export default tourSlice.reducer
